import { atom } from "recoil";

export const orderAtom = atom({
    key: "order-atom",
    default: {
        "user": "",
        "title": "",
        "phone": "",
        "status": "pending",
        "date": new Date().toISOString(),
        "total": 0,
        "items": [],
        "type": "",
        "address": {},
        "payment": "",
        "deliveryCharge": 0, 
        "amountInHand": 0,
        "charge": null,
        "note": ""
    }
})